import React from 'react'

import { Stack } from '@zet/design-system/layout'
import { Text } from '@zet/design-system/typography'
import { styled } from 'nativewind'

const Badge = ({ count = 0 }: { count: number }) => {
  const BadgeContainer = styled(
    Stack,
    'aspect-square bg-warning-100 w-[18] rounded-lg items-center justify-center py-0 px-1 mt-1 -ml-1'
  )

  return (
    <BadgeContainer className=" absolute -right-1 -top-1  ">
      <Text semibold className="text-neutral-white100 text-[10px] leading-4 ">
        {count}
      </Text>
    </BadgeContainer>
  )
}

export default Badge
